var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotificationActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_406_5099)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00833 2.48008C7.59735 0.891059 9.75253 -0.00164795 11.9998 -0.00164795C14.247 -0.00164795 16.4022 0.891057 17.9912 2.48008C19.5802 4.06911 20.473 6.22429 20.473 8.47151V16.0368C20.473 16.5669 20.6835 17.0754 21.0584 17.4503C21.4837 17.8756 21.818 18.0357 22.2855 18.0357C22.7588 18.0357 23.1426 18.4193 23.1426 18.8928C23.1426 19.3661 22.7588 19.75 22.2855 19.75H1.71408C1.24069 19.75 0.856934 19.3661 0.856934 18.8928C0.856934 18.4193 1.24069 18.0357 1.71408 18.0357C2.18156 18.0357 2.51578 17.8756 2.94115 17.4503C3.31601 17.0754 3.52659 16.5669 3.52659 16.0368V8.47151C3.52659 6.22429 4.41931 4.06911 6.00833 2.48008ZM8.99979 22.7143C8.99979 22.0043 9.57543 21.4286 10.2855 21.4286H13.7141C14.4242 21.4286 14.9998 22.0043 14.9998 22.7143C14.9998 23.4244 14.4242 24 13.7141 24H10.2855C9.57543 24 8.99979 23.4244 8.99979 22.7143Z",
    fill: "#13100F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 2,
    height: 5,
    rx: 1,
    transform: "rotate(90 10 8)",
    fill: "#F9DF35"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 2,
    height: 3,
    rx: 1,
    transform: "rotate(90 8 11)",
    fill: "#F9DF35"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_406_5099"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationActive);
export default __webpack_public_path__ + "static/media/icon_notification_active.d7579fd4833ef007845dd2fe1ce88c3d.svg";
export { ForwardRef as ReactComponent };